import { gsap } from "gsap";

export default el => {
    // Cache des éléments DOM
    const btn = el.querySelector('.btn');
    const hides = el.querySelectorAll('.js-cursor-btn-hide');
    
    // Variables d'état
    let mouseX = 0;
    let mouseY = 0;
    let btnX = 0;
    let btnY = 0;
    const speed = 0.07;
    let isHiding = false;
    let animationFrameId = null;

    const initPositions = () => {
        const rect = el.getBoundingClientRect();
        mouseX = btnX = rect.width / 2;
        mouseY = btnY = rect.height / 2;
    };
    initPositions();

    const handleMouseMove = (e) => {
        const rect = el.getBoundingClientRect();
        mouseX = e.x - rect.x;
        mouseY = e.y - rect.y;
        
        if (!isHiding) {
            btn.classList.add('active');
        }
    };

    const handleMouseOut = () => {
        btn.classList.remove('active');
    };

    const handleHideMouseOver = () => {
        isHiding = true;
        btn.classList.remove('active');
    };

    const handleHideMouseOut = () => {
        isHiding = false;
    };

    const animate = () => {
        const distX = mouseX - btnX;
        const distY = mouseY - btnY;

        btnX += distX * speed;
        btnY += distY * speed;

        el.style.setProperty('--left', `${btnX}px`);
        el.style.setProperty('--top', `${btnY}px`);

        animationFrameId = requestAnimationFrame(animate);
    };

    el.addEventListener("mousemove", handleMouseMove, { passive: true });
    el.addEventListener("mouseout", handleMouseOut);
    
    hides.forEach(hide => {
        hide.addEventListener("mouseover", handleHideMouseOver);
        hide.addEventListener("mouseout", handleHideMouseOut);
    });

    animate();

    return () => {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }
        el.removeEventListener("mousemove", handleMouseMove);
        el.removeEventListener("mouseout", handleMouseOut);
        hides.forEach(hide => {
            hide.removeEventListener("mouseover", handleHideMouseOver);
            hide.removeEventListener("mouseout", handleHideMouseOut);
        });
    };
};
